import React from 'react';
import { Grid, Tooltip, IconButton } from '@mui/material';
import IPhoneIcon from '@mui/icons-material/PhoneIphone';
import DeleteIcon from '@mui/icons-material/Delete';

function AppCenterButtons({
  onAddToIOS,
  onDeleteIOS,
  showIOSAdd,
  showIOSEdit,
}) {
  return (
    <Grid container direction="row" justifyContent="flex-end">
      {showIOSAdd && (
      <Tooltip title="Add to IOS">
        <IconButton onClick={onAddToIOS}>
          <IPhoneIcon />
        </IconButton>
      </Tooltip>
      )}
      {showIOSEdit && (
      <Grid item>
        <Tooltip title="Delete IOS">
          <IconButton onClick={onDeleteIOS}>
            <IPhoneIcon />
            <DeleteIcon style={{ color: 'red' }} />
          </IconButton>
        </Tooltip>
      </Grid>
      )}
    </Grid>
  );
}

export default AppCenterButtons;
